 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"route-about","3":"route-aisociallab","4":"route-becomeanexpert","5":"route-becomeapartner","6":"route-careers","7":"route-charts","8":"route-chatbotstudio","9":"route-chatbotstudio-ai","10":"route-chatbotstudio-analytics","11":"route-chatbotstudio-apis","12":"route-chatbotstudio-customization","13":"route-chatbotstudio-home","14":"route-chatbotstudio-live-chat","15":"route-chatbotstudio-multichannel","16":"route-chatbotstudio-multimedia","17":"route-chatbotstudio-pricing","18":"route-chatbotstudio-tree-builder","19":"route-chatbotstudio-voice","20":"route-contacts","21":"route-cookies","22":"route-crisismanagement","23":"route-digitaltwin","24":"route-digitaltwinlist","25":"route-enterprisesolution","26":"route-experts","27":"route-faqs","28":"route-forbes","29":"route-forbeshrassistant","30":"route-forbesleadinsights","31":"route-forbesresearch","32":"route-forgotpw","33":"route-home","34":"route-interview","35":"route-landinguniversity","36":"route-login","37":"route-metaverse","38":"route-michelangelo","39":"route-omnichannel","40":"route-onlineleadgen","41":"route-openai","42":"route-partners","43":"route-pricing","44":"route-privacy","45":"route-register","46":"route-riskcalculator","47":"route-schools","48":"route-terms","49":"route-website_disclaimer"}[chunkId]||chunkId) + ".chunk." + {"2":"60c65","3":"63ef2","4":"197b7","5":"b5867","6":"04acd","7":"114b3","8":"b854e","9":"92bd0","10":"2399a","11":"3bc4e","12":"468bb","13":"cb685","14":"ecc57","15":"e7c13","16":"122f9","17":"d333b","18":"b336e","19":"d7a96","20":"434ea","21":"8262e","22":"11d8c","23":"79d36","24":"67ed5","25":"d6d3f","26":"02fe7","27":"fb980","28":"afb26","29":"f4a0a","30":"f8b7c","31":"ba13a","32":"46508","33":"f9c04","34":"8b1be","35":"7ebc8","36":"1692c","37":"a2f90","38":"818cd","39":"20935","40":"80677","41":"dc05f","42":"f11c6","43":"13bcc","44":"d75da","45":"3546a","46":"ab016","47":"d75b8","48":"8452a","49":"baf5d"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"48":1,"49":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"route-about","3":"route-aisociallab","4":"route-becomeanexpert","5":"route-becomeapartner","6":"route-careers","7":"route-charts","8":"route-chatbotstudio","9":"route-chatbotstudio-ai","10":"route-chatbotstudio-analytics","11":"route-chatbotstudio-apis","12":"route-chatbotstudio-customization","13":"route-chatbotstudio-home","14":"route-chatbotstudio-live-chat","15":"route-chatbotstudio-multichannel","16":"route-chatbotstudio-multimedia","17":"route-chatbotstudio-pricing","18":"route-chatbotstudio-tree-builder","19":"route-chatbotstudio-voice","20":"route-contacts","21":"route-cookies","22":"route-crisismanagement","23":"route-digitaltwin","24":"route-digitaltwinlist","25":"route-enterprisesolution","26":"route-experts","27":"route-faqs","28":"route-forbes","29":"route-forbeshrassistant","30":"route-forbesleadinsights","31":"route-forbesresearch","32":"route-forgotpw","33":"route-home","34":"route-interview","35":"route-landinguniversity","36":"route-login","37":"route-metaverse","38":"route-michelangelo","39":"route-omnichannel","40":"route-onlineleadgen","41":"route-openai","42":"route-partners","43":"route-pricing","44":"route-privacy","45":"route-register","46":"route-riskcalculator","47":"route-schools","48":"route-terms","49":"route-website_disclaimer"}[chunkId]||chunkId) + ".chunk." + {"2":"69248","3":"31491","4":"495f0","5":"04004","6":"008d3","7":"18fda","8":"31d6c","9":"46d5d","10":"b7dce","11":"b7dce","12":"b7dce","13":"b7dce","14":"b7dce","15":"46d5d","16":"b7dce","17":"b7dce","18":"b7dce","19":"b7dce","20":"89630","21":"c272a","22":"b2bfa","23":"bc5a5","24":"9e52c","25":"31d6c","26":"a3d27","27":"31d6c","28":"31d6c","29":"31d6c","30":"31d6c","31":"31d6c","32":"90aef","33":"6beac","34":"bc5a5","35":"3ba37","36":"90aef","37":"beb79","38":"f6b8a","39":"1c3a7","40":"31d6c","41":"a2482","42":"099e7","43":"0be29","44":"c272a","45":"5fc61","46":"31d6c","47":"9a4a3","48":"c272a","49":"c272a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.querlo.com/public/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "Pq/i");
